export const miniAppUrlMap = {
  1: 'http://miniapp.tanchi0757.shop', // 贪吃taste
  1688: 'http://miniapp.boomsj.com', // 贪吃商城
  2: 'https://miniapp.egg.tanchi0757.shop', // 吃团团egg
  1888: 'https://miniapp.egg.tanchi.shop', // 吃团团
  7: 'https://miniapp.travel.tanchi0757.shop', // 贪吃酒旅
  1999: 'https://miniapp.travel.tanchi.shop' // 贪吃酒旅
}
